import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_PRICING_PROFILE_DATE_RANGE,
  CLEAR_PRICING_PROFILE_DATE_RANGES,
  CLEAR_PRICING_PROFILE_DATE_RANGE_FILTER,
  FLAG_GETTING_PRICING_PROFILE_DATE_RANGES,
  FLAG_PRICING_PROFILE_DATE_RANGE_ACTIVITY,
  GET_PRICING_PROFILE_DATE_RANGE,
  GET_PRICING_PROFILE_DATE_RANGES,
  GET_PRICING_PROFILE_DATE_RANGE_FILTER,
} from '../../../actions/types/sales/PricingProfileDateRange';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
    filter: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_PRICING_PROFILE_DATE_RANGES:
      return state.setIn(['all', 'loading'], payload);

    case GET_PRICING_PROFILE_DATE_RANGES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));

    case CLEAR_PRICING_PROFILE_DATE_RANGES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );

    case GET_PRICING_PROFILE_DATE_RANGE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));

    case CLEAR_PRICING_PROFILE_DATE_RANGE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));

    case GET_PRICING_PROFILE_DATE_RANGE_FILTER:
      return state.setIn(['current', 'filter'], Immutable.List(payload));

    case CLEAR_PRICING_PROFILE_DATE_RANGE_FILTER:
      return state.setIn(
        ['current', 'filter'],
        INITIAL_STATE.getIn(['current', 'filter']),
      );

    case FLAG_PRICING_PROFILE_DATE_RANGE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );

    default:
      return state;
  }
};
